import { render } from "./AdDocViewTransactionFootStep.vue?vue&type=template&id=fa9be90a&scoped=true&ts=true"
import script from "./AdDocViewTransactionFootStep.vue?vue&type=script&lang=ts"
export * from "./AdDocViewTransactionFootStep.vue?vue&type=script&lang=ts"

import "./AdDocViewTransactionFootStep.vue?vue&type=style&index=0&id=fa9be90a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa9be90a"]])

export default __exports__